if (!window.Eurus.loadedScript.has('menu-drawer.js')) {
window.Eurus.loadedScript.add('menu-drawer.js');

document.addEventListener("alpine:init", () => {
    Alpine.store('xMenuDrawer', {
      show: false,
      loading: false,
      currentMenuLinks: [],
      open() {
        this.show = true;
        Alpine.store('xPopup').open = true;
      },
      close() {
        this.show = false;
        Alpine.store('xPopup').close();
      },
      setActiveLink(linkId) {
        this.currentMenuLinks.push(linkId);
      },
      removeActiveLink(linkId) {
        const index = this.currentMenuLinks.indexOf(linkId);
        if (index !== -1) {
          this.currentMenuLinks.splice(index, 1);
        }
      },
      resetMenu() {
        this.currentMenuLinks = [];
      },
      scrollTop(el = null) {
        document.getElementById('menu-navigation').scrollTop = 0;
        if (el) {
          el.closest('.scrollbar-body').scrollTop = 0;
        }
      }
    });
  });
}

function markMenuReady() {
  const menuStore = window.Alpine?.store('xMenuDrawer');
  const popupStore = window.Alpine?.store('xPopup');

  if (menuStore && popupStore) {
    document.documentElement.classList.add('menu-drawer-ready');
    document.documentElement.classList.remove('menu-js-loading');
    return true;
  }

  return false;
}

// Skjul fallback, når begge Alpine-stores er klar
document.addEventListener('alpine:init', () => {
  queueMicrotask(markMenuReady);
});

document.addEventListener('alpine:initialized', markMenuReady);

// Håndter tilfælde, hvor Alpine allerede er initialiseret
markMenuReady();